export const PATH_FOR_AGENT_REPORT = '/kalkulator-nedvizhimosti-specialist/';
export const PATH_FOR_ALL_USERS = '/kalkulator-nedvizhimosti/';
